<div #scrollElement class="error-input">
    <span>{{getPreValue()}}</span>
    <span *ngIf="error" class="error">{{error.value}}</span>
    <span>{{getNextValue()}}</span>
    <span *ngIf="!(error && error.tip) && tip && tip.length" class="tip">{{getTip|fn:tip}}</span>
    <span *ngIf="!(error && error.tip) && tip && tip.style" [ngStyle]="tip.style"
        class="tip" [nTextTips]="getTip(tip.value)" nTextTipsPlacement="top">{{getTip(tip.value)}}</span>
    <span *ngIf="error && error.tip" class="error-tip" [nTextTips]="getTip(error.tip)" nTextTipsPlacement="top">
        {{getTip|fn:error.tip}}</span>
    <div *ngIf="!isFocus && selectAble && tip &&tip.timeSelect" class="timeSelect">
        <n-calendar-picker (onOk)="selectTime($event)" [format]='"YYYY-MM-DD"' [(value)]="dataValue"></n-calendar-picker>
    </div>
</div>

